var exports = {
  "az": "Box__hQkgDR",
  "wy": "Box_1__tK-bhP",
  "pv": "Box_2__cfWVdj",
  "m4": "Octicon___ofwS1",
  "DZ": "Heading__uVClHG",
  "w9": "Box_3__9IN8dt",
  "pQ": "Box_4__47vjPr",
  "EY": "Text__WUT9ze",
  "ws": "Box_5__tFiRWf",
  "D6": "Box_6__oH0JNj",
  "KI": "Box_7__3YrYF7",
  "UE": "Text_1__iFiDb7",
  "pm": "Box_8__J5wFR6",
  "Nl": "Text_2__8iF38s",
  "hl": "fadeInAuthor__6Lia9N",
  "dY": "fade-in__ZiWOAK",
  "cp": "avatarLink__YX4Thj",
  "N1": "headerContainer___tCiBV",
  "$r": "authorNameLink__i54eRU",
  "Wp": "authorNameText__5ehKdr",
  "jS": "prLink__r5wFz1",
  "aE": "commitMetadataContainer__3FFhV1",
  "Bh": "commitCountLink__Yy-Eaa",
  "Uf": "commitCountText__Wqu2kc",
  "wi": "Footer__CCByup",
  "zu": "FeedbackButtons__bssQgr",
  "dK": "isHidden__BT1_Dg",
  "KW": "relativeTime__yshpFR",
};

module.exports = exports;
